<template>
  <v-container class="landing-container">
    <!-- Hero Section -->
    <v-row class="mb-16">
      <v-col cols="12" class="hero-section">
        <v-container>
          <v-row align="stretch" justify="center">
            <v-col cols="12" md="6" class="text-center">
              <h1 class="text-h2 font-weight-bold mb-6" style="color: #2ab3b8">
                Transform Your Market Research
              </h1>
              <p class="text-h5 mb-8">
                Get deeper insights through AI-powered natural conversations
              </p>
              <div class="d-flex justify-center">
                <v-btn
                  x-large
                  color="#2ab3b8"
                  class="white--text mr-4"
                  elevation="2"
                  to="/login"
                >
                  Sign Up Now
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
                <v-btn
                  x-large
                  color="#2ab3b8"
                  class="white--text mr-4"
                  elevation="2"
                  to="/login"
                >
                  Log In
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" md="6" class="pa-0">
              <div class="hero-image-wrap">
                <v-img
                  src="assets/cover.jpg"
                  alt="Dynamic Insights Hero"
                  height="100%"
                  cover
                ></v-img>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <!-- Use Cases Section - Now more prominent -->
    <v-row id="use-cases" class="mb-16">
      <v-col cols="12">
        <v-card color="#2ab3b8" dark class="pa-12" style="border-radius: 12px">
          <h2 class="text-h3 text-center mb-12">Use Cases</h2>
          <v-row>
            <v-col
              v-for="(useCase, index) in useCases"
              :key="index"
              cols="12"
              sm="6"
            >
              <v-card
                elevation="2"
                hover
                style="border-radius: 12px; background: white"
                class="pa-6 h-100"
                light
              >
                <v-row no-gutters>
                  <v-col>
                    <h3 class="text-h4 mb-4" style="color: #2ab3b8">
                      {{ useCase.title }}
                    </h3>
                    <p class="text-h6 grey--text text--darken-1">
                      {{ useCase.description }}
                    </p>
                  </v-col>
                  <v-col cols="auto">
                    <v-icon color="#2ab3b8" size="32"
                      >mdi-arrow-top-right</v-icon
                    >
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- Benefits Section -->
    <v-row id="benefits" class="mb-16">
      <v-col cols="12">
        <h2 class="text-h3 text-center mb-12" style="color: #2ab3b8">
          Why Choose Dynamic Insights?
        </h2>
        <v-row>
          <v-col
            v-for="(benefit, index) in benefits"
            :key="index"
            cols="12"
            md="3"
          >
            <v-card
              flat
              style="border: 2px solid #2ab3b8; border-radius: 12px"
              class="pa-6 h-100"
            >
              <v-icon color="#2ab3b8" size="36" class="mb-4">{{
                benefit.icon
              }}</v-icon>
              <h3 class="text-h5 mb-4">{{ benefit.title }}</h3>
              <p class="text-subtitle-1">{{ benefit.description }}</p>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Features Section -->
    <v-row id="features" class="mb-16">
      <v-col cols="12">
        <h2 class="text-h3 text-center mb-12" style="color: #2ab3b8">
          Powerful Features
        </h2>
        <v-row>
          <v-col
            v-for="(feature, index) in features"
            :key="index"
            cols="12"
            md="4"
          >
            <v-card
              elevation="2"
              hover
              style="border-radius: 12px"
              class="pa-6 h-100"
            >
              <v-icon color="#2ab3b8" size="40" class="mb-4">{{
                feature.icon
              }}</v-icon>
              <h3 class="text-h5 mb-4">{{ feature.title }}</h3>
              <p class="text-subtitle-1">{{ feature.description }}</p>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Secondary CTA -->
    <v-row class="mb-12">
      <v-col cols="12" sm="8" offset-sm="2">
        <v-card
          elevation="4"
          class="text-center pa-12"
          style="
            border-radius: 16px;
            background: linear-gradient(135deg, #2ab3b8, #1e9599);
          "
        >
          <h2 class="text-h4 white--text mb-6">
            Ready to Transform Your Market Research?
          </h2>
          <v-btn x-large class="white text--primary" elevation="2" to="/login">
            Sign Up Now
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import APIService from "@/services/APIService";

export default {
  name: "DynamicInsightsLanding",
  components: {},
  data() {
    return {
      name: "",
      email: "",
      submitted: false,
      quickLinks: [
        { text: "Benefits", target: "benefits" },
        { text: "Features", target: "features" },
        { text: "Use Cases", target: "use-cases" },
      ],
      benefits: [
        {
          title: "Natural Conversations",
          description: "Get richer insights through AI-driven natural dialogue",
          icon: "mdi-chat-processing",
        },
        {
          title: "Higher Engagement",
          description: "Achieve better response and completion rates",
          icon: "mdi-chart-bar",
        },
        {
          title: "Honest Feedback",
          description: "Receive more detailed, candid responses",
          icon: "mdi-brain",
        },
        {
          title: "Time Efficient",
          description: "Save significant time compared to traditional methods",
          icon: "mdi-clock-fast",
        },
      ],
      features: [
        {
          title: "Adaptive AI Interviews",
          description:
            "Intelligent conversations that adjust based on responses",
          icon: "mdi-play-circle",
        },
        {
          title: "Quick Setup",
          description: "Start collecting insights in minutes",
          icon: "mdi-flash",
        },
        {
          title: "Advanced Analytics",
          description: "Comprehensive analysis and reporting tools",
          icon: "mdi-chart-line",
        },
      ],
      metrics: [
        {
          stat: "Deeper",
          description: "Richer insights than traditional fixed-choice surveys",
        },
        {
          stat: "Minutes",
          description: "AI-assisted setup gets you collecting insights fast",
        },
        {
          stat: "Rich",
          description: "AI-based analysis of your research results",
        },
      ],
      useCases: [
        {
          title: "Product Feedback",
          description: "Validate features and gather product insights",
        },
        {
          title: "Customer Satisfaction",
          description: "Understand and improve customer experience",
        },
        {
          title: "Market Research",
          description: "Conduct in-depth market analysis",
        },
        {
          title: "User Experience",
          description: "Gather detailed UX feedback",
        },
      ],
    };
  },
  computed: {
    isFormValid() {
      return this.name && this.email;
    },
  },
  methods: {
    handleSubmit() {
      if (this.isFormValid) {
        const to_send = `Name: ${this.name}\nEmail: ${this.email}\n`;
        APIService.sns(`Insight Beta Signup: ${this.name}`, to_send).then(
          (response) => {
            console.log(response.data);
          }
        );
        this.submitted = true;
      }
    },
    scrollTo(target) {
      const element = document.getElementById(target);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      } else if (target === "top") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
  },
};
</script>

<style scoped>
.landing-container {
  background: linear-gradient(to bottom, #ffffff, #f5f5f5);
  min-height: 100vh;
  padding-top: 2rem;
}

.hero-section {
  padding: 4rem 0;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 24px;
  overflow: hidden;
  position: relative;
}

.hero-image-wrap {
  height: 100%;
  min-height: 400px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 50%;
  -webkit-mask-image: linear-gradient(to right, transparent 0%, black 40%);
  mask-image: linear-gradient(to right, transparent 0%, black 40%);
}

.v-card {
  transition: all 0.3s ease;
}

.v-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 25px rgba(42, 179, 184, 0.1);
}

@media (max-width: 1264px) {
  .landing-container {
    padding-top: 1rem;
  }

  .hero-section {
    padding: 2rem 0;
  }
}
</style>
